import { useScrollAnim } from "@components/hooks/hooks"
import Autoplay from "embla-carousel-autoplay"
import useEmblaCarousel from "embla-carousel-react"
import React from "react"

export default function ProjectGalleryDetailSlider({ list }) {
  const [sliderList, setSliderList] = React.useState(list)
  const [trigger, anim] = useScrollAnim()
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      skipSnaps: false,
    },
    [
      Autoplay({
        delay: 3000,
        playOnInit: true,
        stopOnInteraction: false,
        stopOnFocusIn: false,
      }),
    ]
  )

  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [isStart, setIsStart] = React.useState(true)
  const [isEnd, setIsEnd] = React.useState(false)

  const handlePrevClick = () => {
    emblaApi?.scrollPrev()
  }

  const handleNextClick = () => {
    emblaApi?.scrollNext()
  }

  React.useEffect(() => {
    if (!emblaApi) return

    const updateButtonStates = () => {
      setIsStart(!emblaApi.canScrollPrev())
      setIsEnd(!emblaApi.canScrollNext())
      setSelectedIndex(emblaApi.selectedScrollSnap())
    }

    emblaApi.on("select", updateButtonStates)
    updateButtonStates() // Initial state

    const notEnoughToLoop = !emblaApi.internalEngine().slideLooper.canLoop()
    if (notEnoughToLoop) {
      // Write code here that will duplicate slides
      setSliderList([...list, ...list]) // Duplicate the list to ensure looping
      emblaApi.reInit() // Re-init embla to pick up all the slides including the duplicated ones
    }
  }, [emblaApi])

  return (
    <section className="sc-project-gallery-detail-slider py-3" ref={trigger}>
      <div className="container">
        <div className="title-wrapper mb-4">
          <h2 className={`title-section mb-0 ${anim(1)}`}>Gallery</h2>
          <div className={`slider-nav ${anim(2)}`}>
            <button
              onClick={handlePrevClick}
              aria-label="Previous slide"
              className={isStart ? "disabled" : ""}
              disabled={isStart}
            >
              <i className="air ai-chevron-left" />
            </button>
            <button
              onClick={handleNextClick}
              aria-label="Next slide"
              className={isEnd ? "disabled" : ""}
              disabled={isEnd}
            >
              <i className="air ai-chevron-right" />
            </button>
          </div>
        </div>
        <div className={`embla ${anim(3)}`}>
          <div className="embla-viewport" ref={emblaRef}>
            <div className="embla-container">
              {sliderList?.map((image, index) => (
                <div
                  className="embla-slide"
                  key={`carousel-item-gallery-${index}`}
                >
                  <div className="embla-slide-img-wrapper">
                    <img
                      src={image}
                      alt={`Gallery image ${index + 1}`}
                      className="object-cover"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="embla-dots">
            {sliderList?.map((_, index) => (
              <button
                key={`carousel-dot-${index}`}
                className={`embla-dot ${
                  index === selectedIndex ? "embla-dot--selected" : ""
                }`}
                onClick={() => emblaApi?.scrollTo(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
